import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { dataRaw } from "../data2.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    x: {
      ticks: {
        precision: 0,
        color: "#d7d7d7",
      },
      grid: {
        color: "#4b4b4b",
      },
    },
    y: {
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      grid: {
        color: "#4b4b4b",
      },
    },
  },
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      color: "#d7d1ff",
      text: "Cost of Sweating Asset ($)",
    },
  },
};

function App({ assetId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const dataFilter = dataRaw[assetId];

    const labels = [];
    const datas = [];
    dataFilter.map((item) => {
      let quarter = item["Year"];
      labels.push(quarter);
      datas.push(item["Total Cost of Ownership"]);
    });

    const data = {
      labels,
      datasets: [
        {
          label: "Cost of Sweating Asset ($)",
          data: datas,
          backgroundColor: "rgba(180,253,253,0.5)",
        },
      ],
    };
    setData(data);
  }, [assetId]);

  return data ? <Bar options={options} data={data} /> : null;
}
export default App;
